<ngx-spinner></ngx-spinner>
<section class="promotional_sect login-page">
  <a routerLink="" class="cross-icon">
    <span class="icon-close"></span>
  </a>
  <div class="content_sect">
    <a href="javascript:void(none)" routerLink="/login" class="back-arrow"
      ><span class="icon-arrow-left"></span
    ></a>
    <div class="content_text">
      <div class="content_box">
        <div class="left-content">
          <img src="assets/images/logo-white.svg" />
          <div class="login-info">
            <h2 class="mb-2 font-bold">Welcome to Intelligens</h2>
            <h4 class="mb-2 font-bold">
              Stream real shows. Real shows that matter
            </h4>
            <h6 class="content-desk mb-3">
              This is your new home for reality shows with no scripts and
              documentaries with no filters. At Intelligens, we are dedicated to
              bringing you content that is not only entertaining but will also
              offer you a look into worlds you didn't even know existed. Join us
              today and become a part of the Intelligens family.
            </h6>
            <a
              routerLink="/login"
              href="javascript:void(0)"
              class="btn btn-theme text-capitalize"
            >
              {{ "SIGNUP_INFO.BACK_TO_LOGIN" | translate }}</a
            >
          </div>
        </div>

        <div class="right-login">
          <div class="w-100">
            <form class="login otp-plug">
              <p class="font-bold" *ngIf="signupData.type == 'phone'">
                {{ "OTP_VERIFICATION.MESSAGE" | translate }}
              </p>
              <p class="font-bold" *ngIf="signupData.type == 'email'">
                {{ "OTP_VERIFICATION.EMAIL_MESSAGE" | translate }}
              </p>
              <ng-otp-input
                (onInputChange)="onOtpChange($event)"
                [config]="{ length: 4, allowNumbersOnly: true }"
              >
              </ng-otp-input>
              <div class="form-group">
                <button
                  [ngClass]="{ disabled: !btnDisable }"
                  class="btn btn-theme btn-login mb-2"
                  href="javascript:void(0)"
                  (click)="onSubmit()"
                >
                  <span class="spin icon-loader" *ngIf="isLoading"> </span>
                  {{ "OTP_VERIFICATION.VERIFY" | translate }}
                </button>
                <div class="text-center para-color-gray">
                  <a
                    (click)="resendOTP()"
                    href="javascript:void(0)"
                    class="black-link pl-2 orange-link"
                  >
                    {{ "OTP_VERIFICATION.RESEND_OTP" | translate }}
                  </a>
                </div>
              </div>
            </form>
            <div
              class="
                mt-4
                bottom-signup
                text-center
                para-color-gray para-color-gray
              "
            >
              <a
                routerLink="/login"
                href="javascript:void(0)"
                class="orange-link"
                >{{ "OTP_VERIFICATION.BACK_TO_LOGIN" | translate }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
